<template>
    <div class="ls-modals-container">
        <ls-change-address-modal></ls-change-address-modal>
        <ls-faq-modal></ls-faq-modal>
        <ls-how-quoting-works-modal></ls-how-quoting-works-modal>
        <ls-lawn-treatment-modal></ls-lawn-treatment-modal>
        <ls-long-grass-modal></ls-long-grass-modal>
        <ls-one-time-mowing-not-available-modal></ls-one-time-mowing-not-available-modal>
        <ls-terms-of-service-modal></ls-terms-of-service-modal>
        <ls-three-cut-minimum-modal></ls-three-cut-minimum-modal>
    </div>
</template>

<script>
/**
 * Component is used to house all modal components allowing usage of MODAL__OPEN_MODAL action anywhere
 */
import lsChangeAddressModal from '@/components/original-mydot/modals/ChangeAddressModal.vue';
import lsFaqModal from '@/components/original-mydot/modals/FaqModal.vue';
import lsHowQuotingWorksModal from '@/components/original-mydot/modals/HowQuotingWorksModal.vue';
import lsLawnTreatmentModal from '@/components/original-mydot/modals/LawnTreatmentModal.vue';
import lsLongGrassModal from '@/components/original-mydot/modals/LongGrassModal.vue';
import lsOneTimeMowingNotAvailableModal from '@/components/original-mydot/modals/OneTimeMowingNotAvailableModal.vue';
import lsTermsOfServiceModal from '@/components/original-mydot/modals/TermsOfServiceModal.vue';
import lsThreeCutMinimumModal from '@/components/original-mydot/modals/ThreeCutMinimumModal.vue';

export default {
    components: {
        lsChangeAddressModal,
        lsFaqModal,
        lsHowQuotingWorksModal,
        lsLawnTreatmentModal,
        lsLongGrassModal,
        lsOneTimeMowingNotAvailableModal,
        lsTermsOfServiceModal,
        lsThreeCutMinimumModal,
    },
    data() {
        return {};
    },
};
</script>

<style lang="scss"></style>
